import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { InvoiceHistoryVendor } from '../models/invoice-history-vendor';

@Injectable()
export class InvoiceHistoryHttpService {
  private invoiceUrl: string = this.environment.baseUrl + '/api/invoice-history';
  private agencyUrl: string = this.invoiceUrl + '/auth/agency';
  private agencyVendorUrl: string = this.invoiceUrl + '/auth/agency/vendor';
  private propertyUrl: string = this.invoiceUrl + '/auth/property';
  private enabledUrl: string = this.invoiceUrl + '/enabled';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  getInvoiceHistoryAgencyAuth(): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(`${this.agencyUrl}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getInvoiceHistoryPropertyAuth(): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(`${this.propertyUrl}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getInvoiceHistoryEventAgencyAuth(eventId: number): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.get(`${this.agencyUrl}/${eventId}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getInvoiceHistoryEventAgencyVendorAuth(eventId: number, vendor: InvoiceHistoryVendor): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.post(`${this.agencyVendorUrl}/${eventId}`, JSON.stringify(vendor.toJS()), options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getInvoiceHistoryEventPropertyAuth(eventId: number): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.get(`${this.propertyUrl}/${eventId}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getInvoiceHistoryEnabled(): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(`${this.enabledUrl}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/invoice-history.http.service.ts